import React from 'react';

const CVVIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="25" width="38" viewBox="0 0 38.28 23.868">
        <rect ry="3.536" rx="3.536" height="25" width="38" fill="#dfdedc" />
        <rect width="36.28" height="23.868" x=".86" y=".566" rx="3.536" ry="3.536" fill="#cececd" />
        <rect ry="0" rx="0" y="3.995" x=".86" height="4.999" width="36.28" fill="#434244" />
        <rect width="22.449" height="5.031" x="3.157" y="12.682" rx="0" ry="0" fill="#fff" />
        <rect ry="0" rx="0" y="14.448" x="5.501" height="1.5" width="17.762" fill="#434244" />
        <rect ry="0" rx="0" y="12.682" x="28.907" height="5.031" width="4.887" fill="#fff" />
        <rect width="3.23" height="1.5" x="29.735" y="14.448" rx="0" ry="0" fill="#434244" />
        <path
            d="M31.35 9.531c-3.077 0-5.573 2.551-5.573 5.666s2.496 5.666 5.573 5.666c3.076 0 5.574-2.55 5.574-5.666 0-3.115-2.498-5.666-5.574-5.666zm0 1.332c2.342 0 4.24 1.926 4.24 4.334 0 2.408-1.898 4.334-4.24 4.334-2.343 0-4.239-1.926-4.239-4.334 0-2.408 1.896-4.334 4.239-4.334z"
            color="#000"
            overflow="visible"
            fill="#e9574c"
        />
    </svg>
);

export default CVVIcon;



// WEBPACK FOOTER //
// ./src/components/icons/CVVIcon.js